import { VueConstructor } from "vue";
import VueI18n from "vue-i18n";
import { entries } from "lodash";

import rootVueI18n from "@/lib/i18n";

const i18n = new VueI18n({
	messages: {
		fr: {
			"readable.boolean.true": "Oui",
			"readable.boolean.false": "Non"
		}
	}
});

function filter(
	value: any,
	type: "boolean" | "number" | "numeric" | "date" | null = null,
	defaultValue: string | null = null
): string {
	let valueAsString = value;

	if (type === "boolean") {
		value = Boolean(value);
	} else if (type === "number" || type === "numeric") {
		value = parseFloat(value);
	} else if (type === "date") {
		value = String(value);
		const matches = value.match(/(\d\d)(\d\d)(\d{4})/);

		if (matches) {
			const day = parseInt(matches[1], 10);
			const month = parseInt(matches[2], 10) - 1;
			const year = parseInt(matches[3], 10);
			value = new Date(year, month, day);
		}
	}

	if ("boolean" === typeof value || value instanceof Boolean) {
		valueAsString = i18n.t("readable.boolean." + value, rootVueI18n.locale) as string;
	} else if ("number" === typeof value) {
		valueAsString = "" + value;
	} else if (value instanceof Date) {
		valueAsString = value.toLocaleDateString();
	} else if ("object" === typeof value) {
		valueAsString = entries(value)
			.map(entry => entry.join(": "))
			.join(", ");
	}

	if (!valueAsString && defaultValue) {
		valueAsString = defaultValue;
	}

	return valueAsString;
}

export default {
	install(Vue: VueConstructor) {
		Vue.filter("readable", filter);
	}
};

export { filter };
